// extracted by mini-css-extract-plugin
export default {"root":"TooltipShort__root--j6u31","tooltipText":"TooltipShort__tooltipText--3obdY","tooltipButton":"TooltipShort__tooltipButton--pc9EZ"};